<template>
  <div>
    <label>{{ model.$title }}</label>

    <div class="checkbox-list mt-3">
      <w-checkbox
        v-for="(option, index) of options"
        :key="'option_' + index"
        class="mr-3"
        :model="model"
        :value="option.value"
        :title="option.text"
        :show-error="false"
      />
    </div>

    <w-error :model="model" />
  </div>
</template>

<script>
import components from '@witkac/bootstrap4-components';

// @vuese
// Lista checkboxów dla modelu typu `array` typów prostych
export default {
  components,

  props: {
    // Model
    model: { type: Object, required: true },

    // Lista opcji w formacie Array<{text: string, value: string|number}>
    options: { type: Array, required: true }
  }
};
</script>

<style>
.checkbox-list {
  display: flex;
}
</style>
